<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>

<jni-quote-notes-sidebar
  #quotesidebar
  [(display)]="displaySidebar"
  [quoteId]="quoteId"
  [type]="type"
  [rejectionReason]="rejectionReason"
  (refreshOrderNotesGrid)="getSalesOrderNotes()"
  (closeSidebar)="closeSideBarForOrderNotes()"
  (updateHeader)="getSideBarData($event)"></jni-quote-notes-sidebar>

<div class="col-lg-12">
  <p-card class="card-spacing-0">
    <div class="row child p-3 pt-0">
      <span
        class="col-lg-12 mb-3 pb-2 d-flex justify-content-between globalborder-btm-header">
        <span class="head-custom-span">
          <span
            class="col-auto d-flex gap-2 align-items-center inside-custom-span">
            <h2 class="mb-0">
              Proposal #
              <b [title]="quoteId">{{ quoteId }}</b>
            </h2>

            <div
              class="ordersummary-total ms-2 d-flex align-items-center client-badge">
              Status:<b class="px-1">{{ salesOrderStatusD365 }}</b>
            </div>
            <div
              class="ordersummary-total ms-2 d-flex align-items-center client-badge">
              Subtotal:<b class="px-1">{{
                subTotal | currency: foreignCurrency
              }}</b>
            </div>
            <div
              class="ordersummary-status ms-2 d-flex align-items-center client-badge">
              Net:<b class="px-1">{{ net | currency: "USD" }}</b>
            </div>
            <div
              class="ordersummary-status ms-2 d-flex align-items-center client-badge">
              Net GP:<b class="px-1">{{ netGp | currency: "USD" }}</b>
            </div>
            <div
              class="ordersummary-status ms-2 d-flex align-items-center client-badge">
              Net GP%:<b class="px-1"
                ><span *ngIf="getInfinity(netGpPercentage)">
                  {{ netGpPercentage | number: "1.2-2" }}
                </span>
                <span *ngIf="netGpPercentage && getInfinity(netGpPercentage)">{{
                  percentageSign
                }}</span></b
              >
            </div>
            <div
              class="ordersummary-status ms-2 me-auto d-flex align-items-center client-badge">
              <div *ngIf="netCommissionStatus">
                Net est. comm:
                <b class="px-1">{{ commission | currency: "USD" }}</b>
              </div>
            </div>
          </span>
        </span>
        <span class="col-auto d-flex align-items-center right-custom-span">
          <div
            class="ordersummary-panel ml-auto d-flex justify-content-between">
            <div class="ms-3 nav-link p-0 d-flex align-items-center">
              <a class="link" (click)="sendProposalEmail()">
                <i class="pi pi-eye"></i> View Proposal</a
              >
            </div>
            <div class="ms-3 nav-link p-0 d-flex align-items-center">
              <a class="link" (click)="copyCurrentHeader()"
                ><i class="pi pi-copy"></i> Copy</a
              >
            </div>
            <div class="ms-3 nav-link p-0 d-flex align-items-center">
              <a class="link" (click)="onEdit()"
                ><i class="pi pi-pen-to-square"></i> Edit</a
              >
            </div>
            <!-- <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <i class="icon-Add me-2"></i>
        <a class="link" routerLink="/proposal/add-header">New</a>
      </div> -->
            <!-- <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <i class="icon-Add me-2"></i>
        <a class="link" (click)="onQuoteConvert()">Convert</a>
      </div> -->
            <!-- <div ngbDropdown class="mx-2">
              <a
                ngbDropdownToggle
                class="d-flex align-items-center justify-content-center">
                <i class="pi pi-ellipsis-v"></i>
              </a>
              <ul ngbDropdownMenu class="dropdown-menu py-3 mt-1">
                <li>
                  <a class="dropdown-item" (click)="hamburgerAccepted()"
                    >Accepted Proposal</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" (click)="hamburgerRejected()"
                    >Reject Proposal</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" (click)="cancelProposal()"
                    >Cancel Proposal</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" (click)="onQuoteConvert()"
                    >Convert</a
                  >
                </li>
              </ul>
            </div> -->

            <div class="p-menu-icon">
              <p-menu #menu [model]="items" [popup]="true"></p-menu>
              <p-button
                (click)="menu.toggle($event)"
                icon="pi pi-ellipsis-v"
                [link]="true" />
            </div>
          </div>
          <span *ngIf="isModal" class="cross-border" (click)="onCloseModal()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>
      <div class="col-12 proposal-sumary adduser-container-hgt">
        <form [formGroup]="quoteForm" class="">
          <div class="col-12">
            <div class="gray-bg-rounded" formGroupName="orderHeader">
              <div class="row">
                <div class="col mb-2" #myClientDrop>
                  <div
                    class="form-group has-float-label"
                    (click)="onClientRedirect()">
                    <label class="form-label"
                      >Client/Prospect#
                      <span class="madatory-field">*</span></label
                    >
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      formControlName="customerId"
                      (input)="customerVendor$.next($any($event.target).value)"
                      (keyup)="
                        onCustomerSearchOpenToggle(clientPopover, $event)
                      "
                      (keydown.Tab)="getCustomerAccount($event, clientPopover)"
                      [ngClass]="{
                        'has-error': formErrors['customerId'],
                        'has-link': !editHeaderStatus,
                      }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['customerId']">
                      {{ formErrors["customerId"] }}
                    </span>
                  </div>
                  <p-popover
                    class="order-dropdown add"
                    #clientPopover
                    aria-labelledby="dropdownBasic1">
                    <div class="indropdowntable" style="height: 300px">
                      <p-table
                        #dt
                        [value]="customerLists"
                        styleClass="p-datatable-customers order-listing"
                        [rowHover]="true"
                        [rows]="10"
                        [showCurrentPageReport]="true"
                        scrollHeight="290px"
                        [rowsPerPageOptions]="[10, 25, 50]"
                        [paginator]="false"
                        [filterDelay]="0">
                        <ng-template pTemplate="header">
                          <tr>
                            <th class="name">Name</th>
                            <th class="vaccount">Client Account</th>
                            <th class="street" style="width: 100px">Street</th>
                            <th class="city">City</th>
                            <th class="state">State</th>
                            <th
                              class="state"
                              pSortableColumn="billingAttentionD365">
                              Attention
                              <p-sortIcon
                                field="billingAttentionD365"></p-sortIcon>
                            </th>
                            <th class="country">Last order date</th>
                          </tr>
                        </ng-template>
                        <ng-template
                          pTemplate="body"
                          let-customerList
                          let-rowIndex="rowIndex">
                          <tr
                            class="p-selectable-row mousepointer"
                            (click)="
                              onClientSelection(customerList, clientPopover)
                            ">
                            <td class="name mousepointer">
                              {{ customerList.organizationNameD365 }}
                            </td>
                            <td class="vaccount mousepointer">
                              {{ customerList.clientAccount }}
                            </td>
                            <td style="width: 100px" class="sname mousepointer">
                              {{ customerList.street }}
                            </td>
                            <td class="city mousepointer">
                              {{ customerList.city }}
                            </td>
                            <td class="state mousepointer">
                              {{ customerList.state }}
                            </td>
                            <td class="state mousepointer">
                              {{ customerList.billingAttentionD365 }}
                            </td>
                            <td class="country mousepointer">
                              {{
                                customerList.lastOrderDate | date: "yyyy-MM-dd"
                              }}
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td colspan="20">No client found.</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </p-popover>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label ptable-small">
                    <label class="form-label">Buyer</label>
                    <input
                      pInputText
                      #mydropBuyer
                      jniAutoCompleteBlocker
                      type="text"
                      id="buyer"
                      name="buyer"
                      class="form-control"
                      [value]="buyerName"
                      (input)="buyerVendor$.next($any($event.target).value)"
                      (keyup)="onBuyerSearchOpenToggle(buyerPopover, $event)"
                      (keydown.Tab)="getBuyer($event, buyerPopover)"
                      (blur)="logValidationErrors()"
                      (click)="onContactList(buyerPopover, $event)"
                      formControlName="buyer" />
                  </div>
                  <p-popover
                    class="order-dropdown add"
                    #buyerPopover
                    aria-labelledby="dropdownBasic1">
                    <p-table
                      #dt
                      [value]="buyerLists"
                      styleClass="p-datatable-customers order-listing"
                      [rowHover]="true"
                      scrollHeight="calc(100vh - 310px)"
                      scrollHeight="290px"
                      [size]="'small'"
                      [resizableColumns]="true"
                      [rows]="10"
                      [showCurrentPageReport]="true"
                      [rowsPerPageOptions]="[10, 25, 50]"
                      [paginator]="false"
                      [filterDelay]="0"
                      styleClass="table-listing">
                      <ng-template pTemplate="header">
                        <tr class="table-head">
                          <th class="name">Buyer</th>
                          <th class="client" pSortableColumn="client">
                            Client
                            <p-sortIcon field="Client"></p-sortIcon>
                          </th>
                          <th class="vaccount">Account</th>
                          <th class="street">Street</th>
                          <th class="city">City</th>
                          <th class="state">State</th>
                          <th class="lastOrderDate">Last order date</th>
                        </tr>
                        <tr>
                          <th></th>
                          <th>
                            <div class="d-flex">
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                pInputText
                                type="text"
                                name="organizationNameD365"
                                id="organizationNameD365"
                                style="max-width: 200px"
                                (input)="
                                  dt.filter(
                                    $any($event.target).value,
                                    'organizationNameD365',
                                    'contains'
                                  )
                                "
                                placeholder=""
                                class="p-column-filter p-inputtext p-component" />
                            </div>
                          </th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </ng-template>
                      <ng-template
                        pTemplate="body"
                        let-buyerList
                        let-rowIndex="rowIndex">
                        <tr
                          class="p-selectable-row mousepointer"
                          (click)="onBuyerSelection(buyerList, buyerPopover)">
                          <td class="buyer mousepointer">
                            {{ buyerList.buyer }}
                          </td>
                          <td class="client mousepointer">
                            {{ buyerList.organizationNameD365 }}
                          </td>
                          <td class="vaccount mousepointer">
                            {{ buyerList.account }}
                          </td>
                          <td style="width: 200px" class="sname mousepointer">
                            {{ buyerList.street }}
                          </td>
                          <td class="city mousepointer">
                            {{ buyerList.city }}
                          </td>
                          <td style="width: 72px" class="state mousepointer">
                            {{ buyerList.state }}
                          </td>
                          <td style="width: 75px" class="country mousepointer">
                            {{ buyerList.lastOrder | date: "yyyy-MM-dd" }}
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="20">No buyer found.</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </p-popover>
                </div>
                <div
                  *ngIf="editHeaderStatus"
                  class="d-flex justify-content-start pb-1 col mb-2 add-btn"
                  (click)="addContactInformationBuyer()">
                  <a
                    *ngIf="
                      customerBillToObject?.clientAccount && editHeaderStatus
                    "
                    class="link-gray addNewClient nav-link link-gray"
                    ><i class="icon-Add"></i>Add</a
                  >
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label"
                      >Job name <span class="madatory-field">*</span></label
                    >
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      formControlName="jobName"
                      [ngClass]="{ 'has-error': formErrors['jobName'] }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['jobName']">
                      {{ formErrors["jobName"] }}
                    </span>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">ship Date</label>
                    <p-datePicker
                      jniAutoCompleteBlocker
                      inputId="basic"
                      class="date-input"
                      formControlName="shipDate"
                      (onSelect)="onShipDateSelection($event)"
                      [minDate]="shipDateCurrentdate"
                      [ngClass]="{ 'has-error': formErrors['shipDate'] }"
                      (blur)="logValidationErrors()"
                      [showOtherMonths]="true"
                      [selectOtherMonths]="true"></p-datePicker>

                    <span class="error-msg" *ngIf="formErrors['shipDate']">
                      {{ formErrors["shipDate"] }}
                    </span>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label"
                      >In-hands date<span class="madatory-field">*</span></label
                    >
                    <p-datePicker
                      jniAutoCompleteBlocker
                      inputId="basic"
                      class="date-input"
                      formControlName="inHandsDate"
                      (onSelect)="onInHandDateSelection($event)"
                      [minDate]="inHandDateCurrentdate"
                      [ngClass]="{ 'has-error': formErrors['inHandsDate'] }"
                      (blur)="logValidationErrors()"
                      [showOtherMonths]="true"
                      [selectOtherMonths]="true"></p-datePicker>

                    <span class="error-msg" *ngIf="formErrors['inHandsDate']">
                      {{ formErrors["inHandsDate"] }}
                    </span>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label"
                      >Method of Payment
                      <span class="madatory-field">*</span></label
                    >
                    <p-select
                      id="currency"
                      formControlName="methodOfPaymentHeader"
                      (onChange)="getCreditCard($event)"
                      [ngClass]="{
                        'has-error': formErrors['methodOfPaymentHeader'],
                      }"
                      (blur)="logValidationErrors()"
                      [options]="customerPaymentMethodList"
                      optionLabel="Name"
                      optionValue="Name"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>

                    <span
                      class="error-msg"
                      *ngIf="formErrors['methodOfPaymentHeader']">
                      {{ formErrors["methodOfPaymentHeader"] }}
                    </span>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label"
                      >Branding Consultant<span class="madatory-field"
                        >*</span
                      ></label
                    >
                    <input
                      pInputText
                      #bcDropDown
                      jniAutoCompleteBlocker
                      type="text"
                      id="brandingConsultant"
                      name="brandingConsultant"
                      class="form-control"
                      formControlName="brandingConsultant"
                      (click)="onBrandingConsultantSelection(bcPopover, $event)"
                      [ngClass]="{
                        'has-error': formErrors['brandingConsultant'],
                      }"
                      (blur)="logValidationErrors()" />

                    <span
                      class="error-msg"
                      *ngIf="formErrors['brandingConsultant']">
                      {{ formErrors["brandingConsultant"] }}
                    </span>
                  </div>
                  <p-popover
                    #bcPopover
                    aria-labelledby="dropdownBasic4"
                    class="order-dropdown">
                    <p-table
                      #dt
                      [value]="brandingConsultantLists"
                      styleClass="p-datatable-customers order-listing"
                      [rowHover]="true"
                      [rows]="10"
                      [showCurrentPageReport]="true"
                      [rowsPerPageOptions]="[10, 25, 50]"
                      [paginator]="false"
                      [filterDelay]="0">
                      <ng-template pTemplate="header">
                        <tr>
                          <th class="name">Project id</th>
                          <th class="vaccount">Project name</th>
                        </tr>
                      </ng-template>
                      <ng-template
                        pTemplate="body"
                        let-brandingConsultantList
                        let-rowIndex="rowIndex">
                        <tr
                          class="p-selectable-row mousepointer"
                          (click)="
                            onProjectIdSelection(
                              brandingConsultantList,
                              bcPopover
                            )
                          ">
                          <td class="name mousepointer">
                            {{ brandingConsultantList.projectId }}
                          </td>
                          <td class="name mousepointer">
                            {{ brandingConsultantList.projectName }}
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="20">No project found.</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </p-popover>
                </div>

                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label"
                      >Accounts Coordinator<span class="madatory-field"
                        >*</span
                      ></label
                    >
                    <p-select
                      [(ngModel)]="bacUserDefaultSelectionId"
                      formControlName="accountsCoordinator"
                      [ngClass]="{
                        'has-error': formErrors['accountsCoordinator'],
                      }"
                      (onBlur)="logValidationErrors()"
                      [options]="bacList"
                      optionLabel="name"
                      optionValue="personnelNumber"
                      [showClear]="true"
                      [filter]="true">
                      <ng-template let-com="bacList">
                        {{ com.personnelNumber }} : {{ com.name }}
                      </ng-template>
                    </p-select>

                    <span
                      class="error-msg"
                      *ngIf="formErrors['accountsCoordinator']">
                      {{ formErrors["accountsCoordinator"] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="collapse-section border-0 mb-minus-2 mb-3 mt-3">
            <a
              class="btn-collapse-all"
              (click)="onToggle()"
              [ngClass]="{ active: collapseStatus }">
              {{ collapseHeading }} <i class="icon-angle-double"></i>
            </a>
          </div>
          <p-panel
            styleClass="zero-padded"
            [toggleable]="true"
            [showHeader]="false"
            [(collapsed)]="collapseStatus">
            <ng-template pTemplate="content">
              <div
                class="row collapseable"
                [ngClass]="{ active: collapseStatus }">
                <div class="col-3">
                  <div class="gray-bg-rounded" formGroupName="customerAddress">
                    <h3 class="mb-2">Bill To</h3>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Name</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        formControlName="name" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Attention</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        formControlName="billingAttentionD365" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Location</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        formControlName="billingLocationD365" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Address</label>
                      <textarea
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        formControlName="address"></textarea>
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Phone number</label>
                      <input
                        pInputText
                        type="text"
                        class="form-control"
                        formControlName="telephone" />
                    </div>
                  </div>

                  <div class="form-group has-float-label margintop-auto px-3">
                    <div class="d-flex text-wrap-cs p-component">
                      <a class="me-3">
                        Create
                        {{ createdDate | date: "MM-dd-yyyy" }}
                        {{ createdDateName }}
                      </a>
                      <a>
                        Mod
                        {{ lastModifiedDate | date: "MM-dd-yyyy" }}
                        {{ lastModifiedName }}
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="gray-bg-rounded" formGroupName="shipTo">
                    <jni-ship-to-address
                      #shipTo
                      [parent]="quoteForm"
                      [deliveryAddress]="deliveryAddress"
                      [countryRegionList]="countryRegionList"
                      [customerBillToObject]="customerBillToObject"
                      (smallLoaderEvent)="getLoaderStatus($event)"
                      [editHeaderStatus]="editHeaderStatus"
                      [showAddress]="showAddress"
                      [formgroupName]="'shipTo'"
                      [formErrors]="formErrors"
                      [isShipToAddressFromProposal]="true"
                      (validationErrorEvent)="logValidationErrors()">
                    </jni-ship-to-address>
                  </div>
                </div>
                <div class="col-3">
                  <div class="gray-bg-rounded" formGroupName="orderDetails">
                    <div class="d-flex align-items-end justify-content-between">
                      <h3 class="m-0 mb-2">Details</h3>
                    </div>

                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">
                        Client PO number#
                        <span *ngIf="isCustomerPoRequiredField">*</span>
                      </label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        formControlName="customerPONumber"
                        [ngClass]="{
                          'has-error': formErrors['customerPONumber'],
                        }"
                        (blur)="logValidationErrors()" />

                      <span
                        class="error-msg"
                        *ngIf="formErrors['customerPONumber']">
                        {{ formErrors["customerPONumber"] }}
                      </span>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Shipping Method</label>
                          <p-select
                            id="currency"
                            formControlName="shippingMethod"
                            (onChange)="onShippingMethodChange($event)"
                            [options]="shippingProductsList"
                            optionLabel="modeDescriptionD365"
                            optionValue="modeCodeD365"
                            [filter]="true"
                            [showClear]="true">
                          </p-select>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Sell Currency</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="foreignCurrency" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="gray-bg-rounded">
                    <h3 class="mb-2">Estimated Order Totals</h3>
                    <div class="row" formGroupName="estimatedOrderTotals">
                      <div class="col mb-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Estimated Tax:</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            [value]="estimatedTax | currency: foreignCurrency"
                            (focusout)="calculateEstimatedTax($event)"
                            [disabled]="estimatedTaxStatus" />
                        </div>
                      </div>
                      <div class="col mb-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Estimated Freight:</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            [value]="
                              estimatedFreight | currency: foreignCurrency
                            "
                            (focusout)="calculateEstimatedFreight($event)"
                            [disabled]="estimatedFreightStatus" />
                        </div>
                      </div>
                    </div>
                    <div class="row" formGroupName="estimatedOrderTotals">
                      <div class="col-6">
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Recommended Tax</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            [value]="recommendedTax | currency: foreignCurrency"
                            disabled />
                        </div>
                      </div>
                      <div class="col-6 d-flex justify-content-center">
                        <!-- <button
              type="button"
              class="btn btn-primary ms-2"
              (click)="calculateRecommendedTax()">
              Calculate tax
            </button> -->

                        <p-button
                          label="Calculate tax"
                          class="mt-4"
                          (click)="calculateRecommendedTax()" />
                      </div>
                    </div>

                    <div
                      class="form-group has-float-label mb-2"
                      formGroupName="estimatedOrderTotals">
                      <label class="form-label">Order Total:</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        [value]="orderTotal | currency: foreignCurrency"
                        [disabled]="true" />
                    </div>

                    <header
                      class="d-flex align-items-center justify-content-between pb-3 pt-3"
                      formGroupName="estimatedOrderTotals">
                      <h3 class="m-0">Invoice Emails</h3>
                      <a class="icon-Edit ms-3" (click)="editInvoiceEmail()"
                        ><i class="pi pi-pen-to-square"></i> Edit</a
                      >
                    </header>
                    <div class="mb-2" formGroupName="estimatedOrderTotals">
                      <p-table
                        #dt
                        [value]="invoiceEmail"
                        [(selection)]="selectedInvoiceEmail"
                        styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg w-100"
                        [rowHover]="true"
                        [rows]="10"
                        [showCurrentPageReport]="true"
                        [rowsPerPageOptions]="[10, 25, 50]"
                        [paginator]="false"
                        [filterDelay]="0">
                        <ng-template pTemplate="header">
                          <tr>
                            <th class="number">Name</th>
                            <th class="number">Purpose</th>
                            <th class="number">Email</th>
                            <th class="number">Invoice</th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-invoiceEmail>
                          <ng-container>
                            <tr>
                              <td>
                                {{ invoiceEmail.name }}
                              </td>
                              <td>
                                {{ invoiceEmail.purpose }}
                              </td>
                              <td>
                                {{ invoiceEmail.email }}
                              </td>
                              <td class="input-check">
                                <input
                                  disabled
                                  class="form-check-input me-2"
                                  type="checkbox"
                                  [checked]="invoiceEmail.invoice" />
                              </td>
                            </tr>
                          </ng-container>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td colspan="20">No line item found.</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                    <div class="row" formGroupName="quoteStatus">
                      <div class="col mb-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Proposal Accepted</label>
                          <p-datePicker
                            jniAutoCompleteBlocker
                            inputId="basic"
                            class="date-input"
                            formControlName="quoteAccepted"
                            (onSelect)="onProposalAcceptedDateSelection($event)"
                            [ngClass]="{
                              'has-error': formErrors['quoteAccepted'],
                            }"
                            (blur)="logValidationErrors()"
                            [showOtherMonths]="true"
                            [selectOtherMonths]="true"></p-datePicker>
                        </div>
                      </div>
                      <div class="col mb-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Proposal Rejected</label>
                          <p-datePicker
                            jniAutoCompleteBlocker
                            inputId="basic"
                            class="date-input"
                            formControlName="quoteRejected"
                            (onSelect)="onProposalRejectedDateSelection($event)"
                            [ngClass]="{
                              'has-error': formErrors['quoteRejected'],
                            }"
                            (blur)="logValidationErrors()"
                            [showOtherMonths]="true"
                            [selectOtherMonths]="true"></p-datePicker>
                        </div>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                      formGroupName="quoteStatus">
                      <div class="form-group has-float-label flex-grow-1">
                        <div *ngIf="reasonStatus">
                          <p-select
                            formControlName="reason"
                            (onChange)="onReasonChange($event)"
                            [options]="reason"
                            optionLabel="name"
                            optionValue="name"
                            [filter]="true"
                            [showClear]="true">
                          </p-select>
                          <label class="form-label"
                            >Reason<span class="madatory-field">*</span></label
                          >
                        </div>
                      </div>
                      <a
                        *ngIf="reasonStatus"
                        class="icon-Add-notes icon1 ms-3"
                        (click)="onReasonSelection()"></a>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-panel>
        </form>

        <div class="d-flex has-sticky justify-content-end">
          <p-button
            label="Save"
            *ngIf="editHeaderStatus"
            [disabled]="!quoteForm.valid || updateButtonValidation"
            (click)="onHeaderUpdate()" />
        </div>

        <!-- <header
          class="align-items-center d-flex has-border mt-3 ordersummary-header pb-2">
          <h2 class="m-0 wordwrap sec-title">Notes</h2>

          <div
            class="ordersummary-panel ml-auto d-flex justify-content-between">
            <div class="ms-3 nav-link p-0 d-flex align-items-center">
              <i class="icon-Add me-2"></i>
              <a class="link" (click)="openSideBarForOrderNotes()">New</a>
            </div>
          </div>
          <div
            class="ordersummary-panel ml-auto d-flex justify-content-between">
            <div class="ms-3 nav-link p-0 d-flex align-items-center">
              <i class="icon-Edit me-2"></i>
              <a class="link" (click)="updateSideBarForOrderNotes()">Edit</a>
            </div>
          </div>
          <div
            class="ordersummary-panel ml-auto d-flex justify-content-between">
            <div class="ms-3 nav-link p-0 d-flex align-items-center">
              <i class="icon-Delete me-2"></i>
              <a class="link" (click)="deleteSideBarForOrderNotes()">Delete</a>
            </div>
          </div>

          <div
            *ngIf="quotesHeaderData?.salesOrderHeader?.copiedFromHeaderId"
            class="ordersummary-panel ml-auto d-flex text-right"
            style="margin: 0 120px 0 auto; color: #0085fe; font-size: 0.875rem">
            Copied from
            <a
              style="line-height: normal"
              (click)="redirectToCopiedFrom()"
              class="link bold mx-2"
              >{{ setCopiedFromInfo() }}</a
            >
            {{
              quotesHeaderData.salesOrderHeader?.createdDate
                | date: "MM-dd-yyyy"
            }}
          </div>
        </header> -->
        <div class="col-lg-12">
          <div class="gray-bg-rounded mt-3">
            <span class="mb-3 d-flex justify-content-between p-2">
              <span class="col-auto d-flex gap-2 align-items-center">
                <h2 class="mb-0">Notes</h2>
                <div class="collapse-section border-0 mb-minus-5">
                  <a
                    class="btn-collapse-all"
                    (click)="onNotesToggle()"
                    [ngClass]="{ active: collapseNotesStatus }"
                    >{{ collapseNotesHeading }} <i class="icon-angle-double"></i
                  ></a>
                </div>
              </span>

              <span class="col-auto d-flex align-items-center">
                <div
                  class="ordersummary-panel ml-auto d-flex justify-content-between">
                  <div class="ms-3 nav-link p-0 d-flex align-items-center">
                    <a class="link" (click)="openSideBarForOrderNotes()"
                      ><i class="pi pi-plus"></i> New</a
                    >
                  </div>
                </div>
                <div
                  class="ordersummary-panel ml-auto d-flex justify-content-between">
                  <div class="ms-3 nav-link p-0 d-flex align-items-center">
                    <a class="link" (click)="updateSideBarForOrderNotes()"
                      ><i class="pi pi-pen-to-square"></i> Edit</a
                    >
                  </div>
                </div>
                <div
                  class="ordersummary-panel ml-auto d-flex justify-content-between">
                  <div class="ms-3 nav-link p-0 d-flex align-items-center">
                    <a class="link" (click)="deleteSideBarForOrderNotes()"
                      ><i class="pi pi-trash"></i> Delete</a
                    >
                  </div>
                </div>

                <div
                  *ngIf="quotesHeaderData?.salesOrderHeader?.copiedFromHeaderId"
                  class="ordersummary-panel ml-auto d-flex text-right">
                  <a (click)="redirectToCopiedFrom()" class="link bold mx-2">
                    Copied from {{ setCopiedFromInfo() }}

                    {{
                      quotesHeaderData.salesOrderHeader?.createdDate
                        | date: "MM-dd-yyyy"
                    }}
                  </a>
                </div>
              </span>
            </span>

            <div class="cstm-collaspse mb-5">
              <p-panel
                styleClass="zero-padded"
                [toggleable]="true"
                [showHeader]="false"
                [(collapsed)]="collapseNotesStatus">
                <ng-template pTemplate="content">
                  <div class="row collapseable zeroHeight">
                    <jni-quote-notes-grid
                      #quotenotes
                      [quoteId]="quoteId"
                      (selectedOrderNotesListing)="updateLineOnSideBar($event)"
                      [fromSummary]="true">
                    </jni-quote-notes-grid>
                  </div>
                </ng-template>
              </p-panel>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="gray-bg-rounded mt-3">
            <jni-quote-summary-line-items
              [salesOrderLine]="salesOrderLine"
              [OrderLineId]="quoteId"
              [currencyConversion]="currencyConversion"
              [foreignCurrency]="foreignCurrency"
              [releasedProductsList]="releasedProductsList"
              [quoteModalStatus]="quoteModalStatus"
              (changeDetect)="refreshPage($event)"
              (gridRefresh)="getQuoteData(true)"
              (scrollHiddenStatus)="addScollHiddenClass()">
            </jni-quote-summary-line-items>
          </div>
        </div>
      </div>
    </div>
  </p-card>
</div>

<p-dialog
  [closable]="false"
  [(visible)]="displayEmailInvoiceModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  [position]="'center'"
  [autoZIndex]="true"
  appendTo="body">
  <jni-summary-invoice-emails
    #invoiceemail
    [displayEmailInvoiceModal]="displayEmailInvoiceModal"
    [parent]="quoteForm"
    [invoiceListing]="invoiceEmails"
    *ngIf="quoteForm.value"
    (newLine)="addNewLine($event)"
    (removeEmail)="removeEmail($event)"
    [addAndRemoveButtons]="addAndRemoveButtons"
    (closeInvoiceEmailModel)="closeInvoiceEmailModel()"
    (saveInvoiceEmailModel)="saveInvoiceEmailModel($event)"
    (removeInvoiceEmailModel)="removeInvoiceEmailModel($event)">
  </jni-summary-invoice-emails>
</p-dialog>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [isModal]="true"
      [clientIdFromModal]="customerId"
      (closeModalOnRedirectionEvent)="closeModalOnRedirection($event)"
      (scrollHiddenStatus)="addScollHiddenClass()">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="proposalDisplayModal"
  [displayModal]="proposalDisplayModal"
  (closeEvent)="closeModalForProposalEmail()">
  <h1 class="panelHeading mt-5">Proposal Email</h1>
  <div class="panelBody">
    <jni-po-email-quote
      [isModal]="true"
      [quoteId]="quoteId"
      (closeEvent)="closeModalForProposalEmail()"
      (scrollHiddenStatus)="addScollHiddenClass()">
    </jni-po-email-quote>
  </div>
</jni-modal-stacker>

<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [isFromOrdersAddNewBuyer]="true"
  [addClientContact]="addClientContact"
  [customerAccountNumber]="customerAccountNumber"
  (isContactAdded)="isContactAdded($event)"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>
